module.exports = __webpack_public_path__ + "static/media/04.c8869d85.png";